import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';
import { IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight, YouTube, HelpOutline, BugReport } from '@mui/icons-material';
import { Psychology, ListAlt, Construction, SyncAlt, Search, Calculate, FilterList, QueryStats, Analytics, History, CompareArrows } from '@mui/icons-material';



// Custom Discord Icon Component (MUI doesn't have a built-in Discord icon)
const DiscordIcon = ({ sx }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={{ verticalAlign: 'middle', ...sx }}
  >
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z"/>
  </svg>
);

// Custom X Logo Icon Component
const XIcon = ({ sx }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={{ verticalAlign: 'middle', ...sx }}
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

function Sidebar() {
  // Function to detect if device is mobile
  const isMobile = () => {
    return window.innerWidth <= 768; // Common mobile breakpoint
  };

  // Set initial collapsed state based on device type
  const [isCollapsed, setIsCollapsed] = useState(isMobile());

  // Handle window resize to update collapsed state if needed
  useEffect(() => {
    const handleResize = () => {
      if (isMobile() && !isCollapsed) {
        // Optionally auto-collapse on mobile when resizing
        // setIsCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isCollapsed]);

  const toggleSidebar = () => {
    setIsCollapsed(prev => !prev);
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <ul>
        <li className="sidebar-menu-item">
          <NavLink 
            to="/evtool" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <Psychology sx={{ verticalAlign: 'middle', marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'EV Tool'}
          </NavLink>
        </li>
        <li className="sidebar-menu-item">
          <NavLink 
            to="/bettracker" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <ListAlt sx={{ verticalAlign: 'middle', marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'Bet Tracker'}
          </NavLink>
        </li>
        <li className="sidebar-menu-item">
          <NavLink 
            to="/arbitrage" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <SyncAlt sx={{ verticalAlign: 'middle', marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'Arbitrage'}
          </NavLink>
        </li>

                <li className="sidebar-menu-item">
          <NavLink 
            to="/middles" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <CompareArrows sx={{ verticalAlign: 'middle', marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'Middles'}
          </NavLink>
        </li>

        <li className="sidebar-menu-item">
          <NavLink 
            to="/pickem" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <Construction sx={{ verticalAlign: 'middle', marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && "Pick'em"}
          </NavLink>
        </li>
         <li className="sidebar-menu-item">
          <NavLink 
            to="/projections" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <Analytics sx={{ verticalAlign: 'middle', marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'Projections'}
          </NavLink>
        </li>
        <li className="sidebar-menu-item">
          <NavLink 
            to="/odds" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <Search sx={{ verticalAlign: 'middle', marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'Odds Screen'}
          </NavLink>
        </li>
        <li className="sidebar-menu-item">
          <NavLink 
            to="/props" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <FilterList sx={{ verticalAlign: 'middle', marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'Prop Screen'}
          </NavLink>
        </li>

        <li className="sidebar-menu-item">
          <NavLink 
            to="/results" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <QueryStats sx={{ verticalAlign: 'middle', marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'Results'}
          </NavLink>
        </li>
        <li className="sidebar-menu-item">
          <NavLink 
            to="/calculators" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <Calculate sx={{ verticalAlign: 'middle', marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'Calculators'}
          </NavLink>
        </li>
        
        {/* Divider line */}
        {!isCollapsed && (
          <li style={{ 
            margin: '-15px 0',  // Minimal vertical spacing
            padding: '0',
            listStyle: 'none'
          }}>
            <div style={{ 
              borderBottom: '1px solid #444',
              width: '100%',
              marginLeft: '0',
              marginRight: '0'
            }}></div>
          </li>
        )}
        
        {/* Discord Link */}
        <li className="sidebar-menu-item">
          <a 
            href="https://discord.gg/4for4" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="sidebar-link"
            title="Join our Discord"
          >
            <DiscordIcon sx={{ marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'Discord'}
          </a>
        </li>
        
        {/* Help Link */}
        <li className="sidebar-menu-item">
          <a 
            href="https://www.4for4.com/sharpstack-walkthrough-plus-ev-arbitrage-and-pickem-tools" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="sidebar-link"
            title="View Help Documentation"
          >
            <HelpOutline sx={{ verticalAlign: 'middle', marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'Help'}
          </a>
        </li>
               {/* Change Log Link - ADD THIS NEW SECTION */}
        <li className="sidebar-menu-item">
          <NavLink 
            to="/changelog" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <History sx={{ verticalAlign: 'middle', marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'Change Log'}
          </NavLink>
        </li>
        
        {/* Bugs Link */}
        <li className="sidebar-menu-item">
          <NavLink 
            to="/bugs" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <BugReport sx={{ verticalAlign: 'middle', marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'Bugs'}
          </NavLink>
        </li>
        
        {/* X Link */}
        {/* <li className="sidebar-menu-item">
          <a 
            href="https://x.com/your-x-handle" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="sidebar-link"
            title="Follow us on X"
          >
            <XIcon sx={{ marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'X'}
          </a>
        </li> */}
        
        {/* YouTube Link */}
        {/* <li className="sidebar-menu-item">
          <a 
            href="https://youtube.com/@your-youtube-channel" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="sidebar-link"
            title="Subscribe on YouTube"
          >
            <YouTube sx={{ verticalAlign: 'middle', marginRight: isCollapsed ? '0' : '8px', fontSize: '20px' }} />
            {!isCollapsed && 'YouTube'}
          </a>
        </li> */}
        
        <li className="sidebar-menu-item">
          <IconButton
            onClick={toggleSidebar}
            className="collapse-button"
            sx={{
              color: 'white',
              '&:hover': { color: 'white' },
              padding: '0px',
              width: '24px',
              height: '24px',
              marginLeft: isCollapsed ? 'auto' : '120px',
              marginRight: isCollapsed ? 'auto' : '0',
            }}
          >
            {isCollapsed ? <ChevronRight sx={{ fontSize: '20px' }} /> : <ChevronLeft sx={{ fontSize: '20px' }} />}
          </IconButton>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;